import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import theme from 'shared/themes/default';

import Typography from '../Typography';

interface StyledProgressProps {
  small?: boolean;
  progress: number;
}

interface StyledBackgroundProps {
  small?: boolean;
}

const StyledBlock = styled.div`
  position: relative;
  width: 100%;
`;

const StyledProgress = styled.div<StyledProgressProps>`
  height: ${(props) => (props.small ? theme.spacing.xs : '1.25rem')};
  background: ${theme.palette.brand};
  text-align: center;
  overflow: hidden;
  width: ${(props) => props.progress}%;
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  white-space: nowrap;
  border-radius: ${(props) => (props.small ? '6px' : '0')};
`;

const StyledBackground = styled.div<StyledBackgroundProps>`
  height: ${(props) => (props.small ? theme.spacing.xs : '1.25rem')};
  background-color: ${theme.palette.disabledDark};
  border-radius: ${(props) => (props.small ? '6px' : '0')};
`;

interface ProgressBarProps {
  small?: boolean;
  progress: number;
}

const ProgressBar = ({ small, progress }: ProgressBarProps) => {
  const { t } = useTranslation();

  const validatedProgress = Math.max(0, Math.min(100, progress));

  return (
    <StyledBlock>
      <StyledBackground small={small} />
      <StyledProgress small={small} progress={validatedProgress}>
        {validatedProgress === 100 && !small && (
          <Typography
            color={theme.palette.pureDark}
            variant="helperText"
            fontWeight="semibold"
          >
            {t('generic.complete')}
          </Typography>
        )}
      </StyledProgress>
    </StyledBlock>
  );
};

export default ProgressBar;
export type { ProgressBarProps };
